import { ISO8601Duration, Timescale } from '@opallabs/concepts'
import { type MenuOption } from '@opallabs/concepts'

/** @private Only exported for use in tests and stories */
export const supportedTimescales = [
  Timescale.Day,
  Timescale.Week,
  Timescale.Month,
] as const

export function parseRepresentation(
  candidate: ISO8601Duration.Representation | null
): [number, ISO8601Duration.TimeElement] | [] {
  if (!candidate) return []

  try {
    const durationLike = ISO8601Duration.from(candidate)
    const { entry, digits } = ISO8601Duration.getComponent(durationLike)
    return [digits, entry.timeElement]
  } catch {
    return []
  }
}

const zeroDuration = ISO8601Duration.from('P0D')
export function buildRepresentation(
  value: number | undefined,
  unit: ISO8601Duration.TimeElement | undefined
): ISO8601Duration.Representation | null {
  if (!Number.isInteger(value)) return null
  if (!unit) return null

  return ISO8601Duration.toString({
    ...zeroDuration,
    [`${unit}s`]: value,
  })
}

export function validatedUnit(
  candidate: ISO8601Duration.TimeElement | undefined
): ISO8601Duration.TimeElement | undefined {
  if (!candidate) return
  if (supportedTimescales.includes(candidate)) return candidate
}

export function unitOptions(
  value = 0
): MenuOption<ISO8601Duration.TimeElement>[] {
  return ISO8601Duration.components.map(({ formatter, timeElement }) => {
    const label =
      formatter.formatToParts(value).find((p) => p.type === 'unit')?.value ??
      timeElement
    return { label, value: timeElement }
  })
}
